import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Col, Row, Modal, Typography } from 'antd';
import { useParams, useLocation } from 'react-router-dom';
import { withRouter } from 'react-router';
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
// import ToolHeader from 'src/components/Header/toolHeader';
import {
  EVINE_BOOK_LESSON_INFO,
  EVINE_STUDY_DATA,
  GET_USER_LESSON_INFO,
  EVINE_BOOK_RECORDING_INFO,
} from 'src/operations/queries/getEvineLesson';
import { GET_USER_STUDY_COMPLETE_LIST } from 'src/operations/queries/study';
import { CREATE_USER_STUDY } from 'src/operations/mutations/userStudy';
import { useQueryProxy } from 'src/operations/proxy/user';
import _ from 'lodash';
import Loading from 'src/components/common/Loading';
import { ListPage, VocaPage, ListenPage, RCQuizPage, LCQuizPage, GrammarQuizPage, InterpretationPage, WpmPage } from 'src/components/Tool';
import { getCurrentToken } from 'src/utils';
import * as queries from 'src/operations/queries';
const { Title } = Typography;

const wordData = [
  {
    no: 1,
    eng: 'ant',
    kor: '개미',
    eng_audio: '/audio/Voca/ant.mp4',
  },
  {
    no: 2,
    eng: 'apple',
    kor: '사과',
    eng_audio: '/audio/Voca/apple.mp4',
  },
  {
    no: 3,
    eng: 'album',
    kor: '앨범',
    eng_audio: '/audio/Voca/album.mp4',
  },
  {
    no: 4,
    eng: 'bus',
    kor: '버스',
    eng_audio: '/audio/Voca/bus.mp4',
  },
  {
    no: 5,
    eng: 'bat',
    kor: '야구방망이',
    eng_audio: '/audio/Voca/bat.mp4',
  },
  {
    no: 6,
    eng: 'ball',
    kor: '공',
    eng_audio: '/audio/Voca/ball.mp4',
  },
  {
    no: 7,
    eng: 'cat',
    kor: '고양이',
    eng_audio: '/audio/Voca/cat.mp4',
  },
  {
    no: 8,
    eng: 'cup',
    kor: '컵',
    eng_audio: '/audio/Voca/cup.mp4',
  },
  {
    no: 9,
    eng: 'candy',
    kor: '캔디',
    eng_audio: '/audio/Voca/candy.mp4',
  },
];

const getUpdatedList = (quesData, all) => {
  for (let i = 0; i < quesData.length; i++) {
    let randDot = quesData[i]['eng'].trim();
    randDot = randDot.replace(/[<>\[\]]*/g, '');
    quesData[i]['qns'] = randDot.split(' ');
    const total = quesData[i]['qns'].length;
    const maskCount = Math.ceil(total * 0.3);

    const alphaIndexes = quesData[i]['qns']
      .map((word, i) => (/^[a-zA-Z]+$/.test(word.replace(/[^a-zA-Z]/g, '')) ? i : null))
      .filter((i) => i !== null);

    // 4. 후보 중에서 maskCount 개 랜덤 선택
    const maskIndexes = _.sampleSize(alphaIndexes, maskCount);

    quesData[i]['ans'] = randDot;
    const lenrandDot = Math.floor(randDot.replace(/\s*/g, '').length * 0.5);
    let last = 0;
    if (all) {
      randDot = randDot
        .trim()
        .split('')
        .map((v) => {
          if (!v.match(/^[0-9a-zA-Z]+$/)) return v;
          else return '⬤';
        })
        .join('');
    } else {
      const masked = quesData[i]['qns'].map((word, i) => {
        if (maskIndexes.includes(i)) {
          // const letters = word.replace(/[^a-zA-Z]/g, '');
          // const maskedWord = '⬤'.repeat(letters.length);
          return word.replace(/[a-zA-Z]/g, '⬤');
        }
        return word;
      });
      randDot = masked.join(' ');
    }

    quesData[i]['ques'] = randDot;
  }

  return quesData;
};

const defaultData = getUpdatedList(wordData, false);

const titleData = {
  voca: 'Words',
  recording: 'Recording',
  sentence: 'Key Sentence',
  Essay: 'Essay',
  rc: 'Reading Comprehension',
  lc1: 'Listening Comprehension',
  lc2: 'Listening Comprehension',
  grammar: 'Grammar',
  translation: 'Translation',
  dictation1: 'Dictation',
  dictation2: 'Dictation',
};

const Manage = (props) => {
  const { type = 'voca', code = undefined } = useParams();
  const { state } = useLocation();
  const [indx, setIndx] = useState(1);
  const [activeB, setActiveB] = useState(false);
  const [dataSet, setDataset] = useState(false);
  const [bookInfo, setBookInfo] = useState(null);
  const [isBookInfo, setIsBookInfo] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  // const [lessonActualData, setLessonActualData] = useState([]);
  const [lessonData, setLessonData] = useState([]);
  const [getBookInfo, { data: dataBookInfo, loading }] = useLazyQuery(GET_USER_LESSON_INFO, { fetchPolicy: 'no-cache' });
  const [getStudyData, { data: dataStudy, loading: loading2 }] = useLazyQuery(EVINE_STUDY_DATA, { fetchPolicy: 'no-cache' });
  const [getWPMData, { data: wpmdata, loading: loading3 }] = useLazyQuery(EVINE_BOOK_RECORDING_INFO, { fetchPolicy: 'no-cache' });
  const [createUserStudy] = useMutation(CREATE_USER_STUDY, {
    notifyOnNetworkStatusChange: true,
  });
  const token = getCurrentToken();
  const { data: userData } = useQueryProxy(queries.getUser.USER_ME, {
    variables: { token },
  });
  const { data: dataUserStudy } = useQuery(GET_USER_STUDY_COMPLETE_LIST, {
    variables: { user_lesson_idx: state?.user_lesson_idx },
    fetchPolicy: 'no-cache',
  });
  const preset = useMemo(() => {
    if (code && code.length > 0) {
      return code.split('-')[0];
    } else return '';
  }, [code]);
  useEffect(() => {
    if (!isBookInfo && code && code !== 'all') {
      getBookInfo({
        variables: {
          user_lesson_idx: state?.user_lesson_idx,
        },
      });
      setIsBookInfo(true);
    } else if ((code && code === 'all') || !code) {
      setLessonData(defaultData);
      // setLessonActualData(defaultData);
      setDataLoaded(true);
      if (props.onChangeTitle) {
        props.onChangeTitle(titleData[type]);
      }
    }

    if (dataBookInfo?.getUserLessonInfo) {
      let filteredLessonInfo = JSON.parse(JSON.stringify(dataBookInfo?.getUserLessonInfo));
      filteredLessonInfo['stage'] = filteredLessonInfo.stage.filter((f) => f.study_tool);
      setBookInfo(filteredLessonInfo);
      const isComplete = filteredLessonInfo.stage?.every((stageItem) => stageItem.is_complete);
      console.log('isComplete', isComplete);
      let newIndx = indx;
      if (!dataSet) {
        for (let index = 0; index < filteredLessonInfo.stage.length; index++) {
          const element = filteredLessonInfo.stage[index];
          if (element.is_complete && newIndx < filteredLessonInfo.stage.length) {
            newIndx += 1;
          }
        }
        if (!isComplete) {
          setIndx(newIndx);
        }

        setDataset(true);
      }
      if (props.onChangeTitle) {
        props.onChangeTitle(titleData[filteredLessonInfo?.book_lesson?.stage_group_code]);
        // if (
        //   filteredLessonInfo?.book_lesson.stage_group_code === 'essay'
        // ) {
        //   props.onSetHideHeader(true);
        // }
      }
      if (type === 'recording') {
        getWPMData({
          variables: {
            lesson_code: code,
          },
        });
      } else if (filteredLessonInfo?.book_lesson.stage_group_code !== 'recording') {
        getStudyData({
          variables: {
            lesson_code: code,
            study_tool_idx: filteredLessonInfo.stage[newIndx - 1].study_tool.idx,
          },
        });
      } else {
        setDataLoaded(true);
      }
    }
  }, [type, code, dataBookInfo, indx, isBookInfo, getBookInfo, getStudyData, props, dataSet]);

  const sleep = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };

  useEffect(() => {
    if (type === 'sentence' && indx === 3) {
      handleGoNext({}, true);
    }
  }, [indx, type]);

  useEffect(() => {
    if (dataStudy?.getStudyData) {
      // setLessonActualData(JSON.parse(JSON.stringify(dataStudy?.getStudyData?.study_lang_data)));
      let lessondata = dataStudy?.getStudyData;
      if (type === 'rc') {
        lessondata = dataStudy?.getStudyData?.study_quiz_data;
      } else if (type === 'voca' || type.includes('dictation')) {
        lessondata = getUpdatedList(
          JSON.parse(JSON.stringify(dataStudy?.getStudyData?.study_lang_data)),
          bookInfo?.book_lesson.stage_group_code === 'voca' || type === 'dictation2',
        );
      }
      setLessonData(lessondata);
      setDataLoaded(true);
    }
    if (wpmdata?.getRecordingStudyData) {
      setLessonData(wpmdata?.getRecordingStudyData);
      setDataLoaded(true);
    }
  }, [dataStudy, bookInfo, wpmdata]);

  const handleGoBack = (v) => {
    handleUserStudySave(v, goBackCallback);
  };

  const updateNextCallback = useCallback(() => {
    setIndx((prev) => prev + 1);
  }, []);

  const goBackCallback = useCallback(() => {
    props.history.goBack();
  }, [props.history]);

  const handleGoNext = (v, noPopup = false) => {
    if (noPopup) {
      if (indx < bookInfo.stage.length && type !== 'essay') {
        handleUserStudySave(v, updateNextCallback);
      } else {
        handleUserStudySave(v, goBackCallback);
      }
    } else if (indx < bookInfo.stage.length && type !== 'essay') {
      Modal.destroyAll();
      Modal.confirm({
        icon: null,
        title: 'Next',
        content: (
          <Title level={4}>
            {`${v.message ? `${v.message}` : ''}`}
            <br />
            {`Good job!, Let\'s go to next stage.`}
          </Title>
        ),
        onOk: () => handleUserStudySave(v, updateNextCallback),
      });
    } else {
      Modal.destroyAll();
      Modal.confirm({
        icon: null,
        title: 'Exit',
        content: (
          <Title level={4}>
            {`${v.message ? `${v.message}` : ''}`}
            <br />
            {v.exitMessage ? v.exitMessage : ` Are you sure you want to exit?`}
          </Title>
        ),
        onOk: () => handleUserStudySave(v, goBackCallback),
        okText: 'Yes',
        cancelText: 'No',
      });
    }
  };

  const handleChangeIndx = (i) => {
    setActiveB(false);
    setIndx(i);
  };
  const handleUserStudySave = useCallback(
    (studyData = null, c) => {
      if (studyData) {
        try {
          delete studyData['message'];
          delete studyData['exitMessage'];
          createUserStudy({
            variables: {
              user_study_input: {
                ...studyData,
                user_idx: parseInt(userData.me.idx),
                lesson_code: code,
                stage_no: bookInfo.stage[indx - 1]['no'],
                user_lesson_idx: state?.user_lesson_idx,
              },
            },
          }).then(
            () => {
              if (c) {
                c();
              }
            },
            (err) => console.log(err),
          );
          console.log();
        } catch (e) {
          console.log(e);
        }
      }
    },
    [code, userData, state, createUserStudy, bookInfo, indx],
  );
  const handleSaveExit = (studyData) => {
    if (studyData) {
      createUserStudy({
        variables: {
          user_study_input: {
            ...studyData,
            user_idx: parseInt(userData.me.idx),
            lesson_code: code,
            stage_no: bookInfo.stage[indx - 1]['no'],
            user_lesson_idx: state?.user_lesson_idx,
            stat: 0,
          },
        },
      });
    }
  };

  const getSwitchableRoute = (val) => {
    switch (val) {
      case 'voca':
        switch (indx) {
          case 1:
            return <VocaPage preset={preset} isMiddle={true} onClickGoback={handleGoBack} gotoNext={handleGoNext} data={lessonData} />;
          case 2:
            return (
              <ListenPage
                preset={preset}
                isMiddle={true}
                onClickGoback={handleGoBack}
                type="voca"
                data={lessonData}
                gotoNext={handleGoNext}
                listenStageType={2}
                handleSaveExit={handleSaveExit}
                dataUserStudy={dataUserStudy}
              />
            );
          default:
            return <VocaPage preset={preset} isMiddle={true} onClickGoback={handleGoBack} gotoNext={handleGoNext} data={lessonData} />;
        }
      // break;
      case 'dictation1':
        return (
          <ListenPage
            tryCount={3}
            onClickGoback={handleGoBack}
            type="sentence"
            gotoNext={handleGoNext}
            data={lessonData}
            listenStageType={1}
            preset={preset}
            handleSaveExit={handleSaveExit}
            isMiddle={true}
          />
        );
      case 'dictation2':
        return (
          <ListenPage
            isMiddle={true}
            tryCount={3}
            onClickGoback={handleGoBack}
            type="sentence"
            gotoNext={handleGoNext}
            data={lessonData}
            listenStageType={1}
            preset={preset}
            handleSaveExit={handleSaveExit}
          />
        );
      case 'translation':
        return (
          <InterpretationPage
            onClickGoback={handleGoBack}
            data={lessonData?.study_lang_data}
            handleSaveExit={handleSaveExit}
            dataUserStudy={dataUserStudy}
          />
        );
      case 'rc':
        return <RCQuizPage handleSaveExit={handleSaveExit} dataUserStudy={dataUserStudy} onClickGoback={handleGoBack} data={lessonData} />;
      case 'lc1':
        return (
          <LCQuizPage
            handleSaveExit={handleSaveExit}
            dataUserStudy={dataUserStudy}
            saveRef={props.saveRef}
            preset={preset}
            onClickGoback={handleGoBack}
            data={lessonData}
            type={-1}
          />
        );
      case 'lc2':
        return (
          <LCQuizPage
            handleSaveExit={handleSaveExit}
            dataUserStudy={dataUserStudy}
            saveRef={props.saveRef}
            preset={preset}
            onClickGoback={handleGoBack}
            data={lessonData}
            type={0}
          />
        );
      case 'grammar':
        return (
          <GrammarQuizPage
            handleSaveExit={handleSaveExit}
            dataUserStudy={dataUserStudy}
            saveRef={props.saveRef}
            preset={preset}
            onClickGoback={handleGoBack}
            data={lessonData}
            type={0}
          />
        );
      case 'word':
        return <VocaPage preset={preset} isMiddle={true} onClickGoback={handleGoBack} data={lessonData} />;
      case 'recording':
        return <WpmPage onClickGoback={handleGoBack} data={lessonData} userData={userData} code={code} hideHeader={() => {}} />;
      default:
        return <ListPage onClickGoback={handleGoBack} />;
    }
  };

  const getBelowNavigator = (val) => {
    switch (val) {
      case 'voca':
        return (
          <Col span={24} className={`tail__section ${activeB ? 'active' : ''}`} style={{ padding: 0 }}>
            <div className="tail__layer" onClick={() => setActiveB(false)}></div>
            <div className={`tail__box ${activeB ? 'active' : ''}`}>
              <button type="button" className="tail__btn" deluminate_imagetype="png" onClick={() => setActiveB(!activeB)}></button>
              {activeB ? (
                <div className="section__inner">
                  <h3 className="tail__title">
                    <img src="/images/words.png" alt="voca" style={{ maxWidth: 500 }} />
                  </h3>
                  <ul className="tail__process">
                    <li
                      onClick={() => {
                        if (bookInfo.stage[0].is_complete || indx === bookInfo.stage.length) {
                          handleChangeIndx(1);
                        }
                      }}
                    >
                      <img className={`${indx === 1 ? 'active' : ''}`} src="/images/wordintro.png" alt="Intro" />
                    </li>
                    <li
                      onClick={() => {
                        if (bookInfo.stage[1].is_complete || indx === bookInfo.stage.length) {
                          handleChangeIndx(2);
                        }
                      }}
                    >
                      <img className={`${indx === 2 ? 'active' : ''}`} src="/images/wordtype.png" alt="Intro" />
                    </li>
                  </ul>
                </div>
              ) : null}
            </div>
          </Col>
        );
      case 'sentence':
        return (
          <Col span={24} className={`tail__section ${activeB ? 'active' : ''}`} style={{ padding: 0 }}>
            <div className="tail__layer" onClick={() => setActiveB(false)}></div>
            <div className={`tail__box ${activeB ? 'active' : ''}`}>
              <button type="button" className="tail__btn" deluminate_imagetype="png" onClick={() => setActiveB(!activeB)}></button>
              {activeB ? (
                <div className="section__inner">
                  <h3 className="tail__title">
                    <img src="/images/keysentences.png" alt="WORDS" style={{ maxWidth: 500 }} />
                  </h3>
                  <ul className="tail__process">
                    <li
                      onClick={() => {
                        if (bookInfo.stage[0].is_complete || indx === bookInfo.stage.length) {
                          handleChangeIndx(1);
                        }
                      }}
                    >
                      <img className={`${indx === 1 ? 'active' : ''}`} src="/images/keysentencesay.png" alt="Intro" />
                    </li>
                    <li
                      onClick={() => {
                        if (bookInfo.stage[1].is_complete || indx === bookInfo.stage.length) {
                          handleChangeIndx(2);
                        }
                      }}
                    >
                      <img className={`${indx === 2 ? 'active' : ''}`} src="/images/keysentencedictation.png" alt="Intro" />
                    </li>
                    {/* <li onClick={() => handleChangeIndx(3)}>
                      <img className={`${indx === 3 ? 'active' : ''}`} src="/images/keysentencespeak.png" alt="Intro" />
                    </li> */}
                    <li
                      onClick={() => {
                        if (bookInfo.stage[3].is_completev || indx === bookInfo.stage.length) {
                          handleChangeIndx(4);
                        }
                      }}
                    >
                      <img className={`${indx === 4 ? 'active' : ''}`} src="/images/keysentenceunscramble.png" alt="Intro" />
                    </li>
                  </ul>
                </div>
              ) : null}
            </div>
          </Col>
        );
      default:
        return <></>;
    }
  };

  return (
    <>
      <Row gutter={[24, 16]}>
        {dataLoaded ? getSwitchableRoute(type) : null}
        {getBelowNavigator(type)}
      </Row>
    </>
  );
};

export default withRouter(Manage);
